import { LANGUAGES } from '@constants'

/** Normalize the legacy text/JSON language response before rendering any consumer. */
export function normalizeLanguageCode(value: unknown): string {
  let candidate = value
  if (typeof candidate === 'string') {
    const text = candidate.trim()
    candidate = text
    if (text.startsWith('{') || text.startsWith('"')) {
      try {
        candidate = JSON.parse(text)
      } catch {
        /* Fall through to the supported-code check. */
      }
    }
  }
  if (candidate && typeof candidate === 'object' && 'language' in candidate) candidate = candidate.language
  if (typeof candidate !== 'string') return LANGUAGES.EN
  const code = candidate
    .trim()
    .replace(/^['"]|['"]$/g, '')
    .split('-')[0]
    .toLowerCase()
  return (Object.values(LANGUAGES) as readonly string[]).includes(code) ? code : LANGUAGES.EN
}
